<template>
  <div class="checkout-details col-md-12 column-reverse">
    <div class="col-md-8 col-sm-6 ls-no-padding-left form-submit no-padding">
      <form class="ls-lg-space ls-no-padding ls-md-margin-bottom ls-lg-margin-top">
        <MaterialInput
          type="select"
          v-validate="'required'"
          v-model="bank"
          ico="fa fa-credit-card-alt"
          class="col-md-6"
          :class="{ 'material--active material--has-errors': errors.has($t('payments.attributes.banks')) }"
          :data-vv-name="$t('payments.attributes.banks')">
          {{ $t('payments.attributes.banks') }}
          <option slot="options" value="bb_transferência">Banco do Brasil</option>
          <option slot="options" value="bradesco_transferência">Bradesco</option>
          <option slot="options" value="itaú_transferência">Itaú</option>

          <small class="material-errors" slot="help-message" v-if="errors.has($t('payments.attributes.banks'))">{{ errors.first($t('payments.attributes.banks')) }}</small>
          <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('payments.attributes.banks'))" aria-hidden="true"></i>
        </MaterialInput>
        <div class="col-md-6">
          <button v-if="bank" class="btn btn-act btn-lg ls-full-width" @click.prevent="sendPayment">{{ $t('subscribe.buttons.open_transfer') }} </button>
          <button v-else class="btn btn-act btn-lg ls-full-width" disabled>{{ $t('subscribe.buttons.open_transfer') }} </button>
        </div>
      </form>
      <ul class="payment-info">
        <li class="ls-md-margin-bottom" v-for="step in steps">
          <div>
            <i :class="step.icon" aria-hidden="true"></i>
            <p class="ls-no-margin ls-txt-justify" v-html="step.description">{{ step.description }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-md-4 col-sm-6 ls-no-padding-left ls-no-padding-right no-padding">
      <div class="full-height ls-no-padding-left ls-no-padding-right">
        <invoice-details class="ls-md-margin-bottom" :invoice="invoice"></invoice-details>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import InvoiceDetails from './components/InvoiceDetails.vue'
  import MaterialInput from '../../components/shareds/MaterialInput.vue'
  import IconSuccess from 'src/app/components/shareds/icon-animate/success'

  export default {
    name: 'Transfer',
    components: { IconSuccess, InvoiceDetails, MaterialInput },
    data () {
      return {
        bank: '',
        copySucceeded: null,
        steps: [
          {
            description: this.$t('subscribe.messages.payment_confirmation_automatically_transfer'),
            icon: 'fa fa-check-circle-o'
          },
          {
            description: this.$t('subscribe.messages.signature_will_only_be_approved_after_payment_confirmation'),
            icon: 'fa fa-file-text-o'
          }
        ]
      }
    },
    methods: {
      ...mapMutations(['clearFlash', 'addFlash']),
      ...mapActions(['loadSellerData', 'loadInvoiceById', 'pay', 'loadSetting']),
      sendPayment () {
        this.clearFlash()
        this.$loader.show()
        this.pay(this.payParams())
          .then((response) => {
            this.afterPay(response)
          })
      },
      afterPay (response) {
        if (response.status === 200) {
          this.$parent.loadTransferDone()
          this.finished = true
        }
        this.$loader.hide()
      },
      changePaymentMethod () {
        this.clearFlash()
        this.$parent.$data.transfer = false
        this.$parent.$data.choosePayment = true
      },
      payParams () {
        return { id: this.$route.params.id, method: 'transfer', payment_method: this.bank }
      }
    },
    computed: {
      ...mapGetters(['invoice'])
    }
  }
</script>
<style>
  @media (max-width: 767px)
  {
    .column-reverse
    {
      display: flex !important;
      flex-direction: column-reverse;
    }
    .no-padding
    {
      padding: 0px;
    }
  }
</style>
<style lang="scss" scoped>
  .checkout-details {
    display: flex;
    justify-content: stretch;
    padding: 15px;
    @media screen and (max-width: 768px) {
      display: block;
      padding: 0;
      .order-box {
        margin-bottom: 40px;
      }
    }
  }
  .payment-details {
    .payment-icon {
      font-size: 36px;
      margin-right: 10px;
    }
  }
  .form-submit {
    display: flex;
    flex-direction: column;
  }
  .finished {
    max-width: 1206px;
    padding: 0 20px;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }
  .order-box {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    border-radius: 4px;
    border: 1px solid #dddddd;
    padding: 15px;
    > * {
      display: block;
      width: 100%;
    }
    @media screen and (max-width: 768px) {
      background: rgba(0, 0, 0, 0.11);
      border-radius: 0;
      text-align: center;
    }
  }
  .ls-btn {
    margin: 0 auto;
  }
  .btn {
    border: none;
    display: block;
    margin: 0 auto;
  }
  .bar-code {
    padding: 15px;
    font-size: 20px;
    width: 100%;
    color: #717787;
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    .ls-box {
      -webkit-animation: cd-bounce-2 0.6s;
      -moz-animation: cd-bounce-2 0.6s;
      animation: cd-bounce-2 0.6s;
      border: none;
      padding: 0;
    }
  }
  .payment-info {
    list-style: none;
    div {
      display: flex;
      align-items: center;
    }
    i {
      font-size: 40px;
      max-width: 50px;
      display: inline-block;
      padding: 0px 15px 0px 0px;
      @media screen and (max-width: 768px) {
        font-size: 28px;
        display: inline-block;
        padding: 0px 30px 27px 0px;
      }
    }
  }
  .ls-btn[disabled] {
    transform: scale(1.2);
  }
  .check-mark {
    width: 80px;
    height: 130px;
    margin: 0 auto;
  }
  @-webkit-keyframes rotatePlaceholder {
    0% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    5% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    12% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
    100% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
  }
  @keyframes rotatePlaceholder {
    0% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    5% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    12% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
    100% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
  }
  @media only screen and (min-width: 1170px) {
    /* inverse bounce effect on even content blocks */
    .cssanimations .cd-timeline-block:nth-child(even) .cd-timeline-content.bounce-in {
      -webkit-animation: cd-bounce-2-inverse 0.6s;
      -moz-animation: cd-bounce-2-inverse 0.6s;
      animation: cd-bounce-2-inverse 0.6s;
    }
  }
  @-webkit-keyframes cd-bounce-2 {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-100px);
    }

    60% {
      opacity: 1;
      -webkit-transform: translateX(20px);
    }

    100% {
      -webkit-transform: translateX(0);
    }
  }
  @-moz-keyframes cd-bounce-2 {
    0% {
      opacity: 0;
      -moz-transform: translateX(-100px);
    }

    60% {
      opacity: 1;
      -moz-transform: translateX(20px);
    }

    100% {
      -moz-transform: translateX(0);
    }
  }
  @keyframes cd-bounce-2 {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-100px);
      -moz-transform: translateX(-100px);
      -ms-transform: translateX(-100px);
      -o-transform: translateX(-100px);
      transform: translateX(-100px);
    }

    60% {
      opacity: 1;
      -webkit-transform: translateX(20px);
      -moz-transform: translateX(20px);
      -ms-transform: translateX(20px);
      -o-transform: translateX(20px);
      transform: translateX(20px);
    }

    100% {
      -webkit-transform: translateX(0);
      -moz-transform: translateX(0);
      -ms-transform: translateX(0);
      -o-transform: translateX(0);
      transform: translateX(0);
    }
  }
  @-webkit-keyframes cd-bounce-2-inverse {
    0% {
      opacity: 0;
      -webkit-transform: translateX(100px);
    }

    60% {
      opacity: 1;
      -webkit-transform: translateX(-20px);
    }

    100% {
      -webkit-transform: translateX(0);
    }
  }
  @-moz-keyframes cd-bounce-2-inverse {
    0% {
      opacity: 0;
      -moz-transform: translateX(100px);
    }

    60% {
      opacity: 1;
      -moz-transform: translateX(-20px);
    }

    100% {
      -moz-transform: translateX(0);
    }
  }
  @keyframes cd-bounce-2-inverse {
    0% {
      opacity: 0;
      -webkit-transform: translateX(100px);
      -moz-transform: translateX(100px);
      -ms-transform: translateX(100px);
      -o-transform: translateX(100px);
      transform: translateX(100px);
    }

    60% {
      opacity: 1;
      -webkit-transform: translateX(-20px);
      -moz-transform: translateX(-20px);
      -ms-transform: translateX(-20px);
      -o-transform: translateX(-20px);
      transform: translateX(-20px);
    }

    100% {
      -webkit-transform: translateX(0);
      -moz-transform: translateX(0);
      -ms-transform: translateX(0);
      -o-transform: translateX(0);
      transform: translateX(0);
    }
  }
  .green {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// Transfer.vue?62f439b4